const PROGRAM_TAGS = {
    WORKSHOP: 'workshop',
    FUTURE: 'future',
    PRE_RETIREMENT: 'pre-retirement',
    POST_RETIREMENT: 'post-retirement',
};

export default PROGRAM_TAGS;
